import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import GavelIcon from '@mui/icons-material/Gavel';
import InsertLinkIcon from '@mui/icons-material/InsertLink';
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';
import { logout } from 'cloak-auth/src/Client/logout';
import { useAuthStore } from 'cloak-auth/src/Client/stores';

import { MenuItemProps } from '..';
import RenkiAuthIcon from '../../../../Icons/RenkiAuth';

interface PortalMenuItemsProps {
    handleCloseUserMenu: () => void;
    handleContactSupportOpen: () => void;
    hasNext: boolean;
    termsUrl: string | undefined;
}

const handleLogout = async () => {
    try {
        await caches.delete('pwa-cache');
    } catch {
        console.log('cache not available');
    } finally {
        void logout(useAuthStore.getState().keyCloak);
    }
};

export const portalMenuItems = ({
    handleCloseUserMenu,
    handleContactSupportOpen,
    hasNext,
    termsUrl,
}: PortalMenuItemsProps): Record<string, MenuItemProps[]> => {
    const menuItems: Record<string, MenuItemProps[]> = {};

    if (hasNext) {
        menuItems.Tags = [
            {
                handleClick: handleCloseUserMenu,
                icon: <InsertLinkIcon sx={{ color: 'primary.main' }} />,
                label: 'Test Tag',
                to: '/testrenkitag',
            },
        ];
    }

    menuItems.Help = [
        {
            icon: <LiveHelpIcon fontSize="small" sx={{ color: 'mlRed.main' }} />,
            label: 'Help Centre',
            to: 'https://renki.app',
        },
        {
            handleClick: handleContactSupportOpen,
            icon: <ContactSupportIcon fontSize="small" sx={{ color: 'mlBlue.main' }} />,
            label: 'Contact Support',
        },
        {
            icon: <GavelIcon fontSize="small" sx={{ color: 'green.main' }} />,
            label: 'Terms & Conditions',
            to: termsUrl,
        },
    ];

    menuItems.Account = [
        {
            handleClick: handleCloseUserMenu,
            icon: <SettingsIcon fontSize="small" sx={{ color: 'primary.main' }} />,
            label: 'Settings',
            to: '/settings',
        },
        {
            icon: <RenkiAuthIcon fontSize="small" />,
            label: 'Auth Settings',
            to: `${process.env.EXPO_PUBLIC_CLOAK_HOST!}/realms/${process.env.EXPO_PUBLIC_CLOAK_REALM!}/account/#/`,
        },
        {
            handleClick: () => {
                void handleLogout();
            },
            icon: <LogoutIcon fontSize="small" sx={{ color: 'gray' }} />,
            label: 'Logout',
        },
    ];

    return menuItems;
};
